import OperationRepository from '@/libs/customAxios/operationAxios'

const resource = '/merchant/service-type'

export default {
  getServiceTypeDropdown() {
    return OperationRepository.get(`${resource}/dropdown`)
  },
}
